var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNovisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6 2.827C7.059 2.719 7.529 2.666 8 2.667C12.667 2.667 15.333 8 15.333 8C14.929 8.757 14.446 9.47 13.893 10.127M9.413 9.413C9.23 9.61 9.009 9.767 8.764 9.877C8.519 9.986 8.254 10.045 7.985 10.05C7.717 10.054 7.45 10.005 7.201 9.904C6.952 9.804 6.726 9.654 6.536 9.464C6.346 9.274 6.196 9.048 6.096 8.799C5.995 8.55 5.946 8.283 5.95 8.015C5.955 7.746 6.014 7.481 6.123 7.236C6.233 6.991 6.39 6.77 6.587 6.587M11.96 11.96C10.82 12.829 9.433 13.31 8 13.333C3.333 13.333 0.667 8 0.667 8C1.496 6.455 2.646 5.104 4.04 4.04L11.96 11.96Z",
    stroke: "#5C6F7E",
    strokeWidth: 1.3333333333333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.667 0.667L15.333 15.333",
    stroke: "#5C6F7E",
    strokeWidth: 1.3333333333333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_753"
  }, /*#__PURE__*/React.createElement("path", {
    width: 24,
    height: 24,
    fill: "white",
    d: "M0 0H16V16H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovisible);
export default __webpack_public_path__ + "static/media/novisible.b83471c0b13aebc9d38e9fa7eaa5eadf.svg";
export { ForwardRef as ReactComponent };